export default {
  root: {
    backgroundColor: '#dee2e6'
  }
};
